const DAY_MS = 24 * 3600 * 1000;

/**
 * How many days past its run a model forecasts, read from the rows loaded, or undefined when they
 * cannot tell. The rows are read within the chart's dates, and the server keeps none at or past the
 * range's end, so a frame whose next row would fall there was cut short and says nothing about how
 * far the model forecasts.
 */
export function forecastHorizonDays(
  frames: {initTime: Date; validTimes: Date[]}[],
  rangeEnd: Date
): number | undefined {
  const spans = frames
    .filter((frame) => frame.validTimes.length > 1)
    .filter((frame) => {
      const last = frame.validTimes[frame.validTimes.length - 1].getTime();
      const step = last - frame.validTimes[frame.validTimes.length - 2].getTime();
      return last + step < rangeEnd.getTime();
    })
    .map(
      (frame) => frame.validTimes[frame.validTimes.length - 1].getTime() - frame.initTime.getTime()
    );
  const days = spans.length > 0 ? Math.round(Math.max(...spans) / DAY_MS) : 0;
  return days > 0 ? days : undefined;
}
